var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess4Qcs25Ww(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.48 4.48 0 10 0s10 4.48 10 10-4.48 10-10 10S0 15.52 0 10zm8.707 1.293L14 6l1.414 1.414-6.707 6.707L5 10.414 6.414 9l2.293 2.293z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDEwQzAgNC40OCA0LjQ4IDAgMTAgMEMxNS41MiAwIDIwIDQuNDggMjAgMTBDMjAgMTUuNTIgMTUuNTIgMjAgMTAgMjBDNC40OCAyMCAwIDE1LjUyIDAgMTBaTTguNzA3MTEgMTEuMjkyOUwxNCA2TDE1LjQxNDIgNy40MTQyMUw4LjcwNzExIDE0LjEyMTNMNSAxMC40MTQyTDYuNDE0MjEgOUw4LjcwNzExIDExLjI5MjlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgSuccess4Qcs25Ww as ReactComponent };